import './ErrorComponent.scss'

export type LoadingProps = {
  message?: string
}

export function ErrorComponent(props: LoadingProps) {
  const message = props.message ?? 'Error while fetching content'

  return (
    <div className="loading">
      <div>{message}</div>
    </div>
  )
}
